<footer class="point__footer">
  <ci-icon
    class="point__icon"
    name="more-portrait"
    type="svg"
  ></ci-icon>
</footer>